// Base de connaissances de Georges le Majordome
// Réponses aux questions fréquentes sur l'utilisation de l'application

export const GUIDES = {
  devis: {
    titre: "Créer un devis",
    icone: "📋",
    etapes: [
      "Allez dans **Devis** → cliquez sur **Nouveau devis**",
      "Sélectionnez ou saisissez le nom de l'enfant",
      "Choisissez la structure (Ptis Lu ou Choubidoux)",
      "Cochez les jours de garde et saisissez les horaires (ex: 8h00 → 17h30)",
      "Le tarif et le montant mensuel se calculent **automatiquement**",
      "Cliquez sur **Enregistrer** puis **Générer le PDF** pour l'imprimer ou l'envoyer"
    ]
  },
  enfant: {
    titre: "Ajouter un enfant",
    icone: "👶",
    etapes: [
      "Allez dans **Enfants** → cliquez sur **Nouvel enfant**",
      "Remplissez les informations de l'enfant (nom, prénom, date de naissance...)",
      "Ajoutez les informations du **Parent 1** (obligatoire)",
      "Ajoutez les informations du **Parent 2** si besoin",
      "Renseignez les éventuelles allergies ou un PAI",
      "Cliquez sur **Enregistrer** — vous pouvez ensuite créer un devis directement depuis la fiche"
    ]
  },
  contrat: {
    titre: "Créer un contrat",
    icone: "📄",
    etapes: [
      "Créez d'abord un **devis accepté** pour l'enfant",
      "Dans le détail du devis, cliquez sur **Convertir en contrat**",
      "Vérifiez les informations et la date de début",
      "Le contrat est créé avec statut **Actif**",
      "Vous pouvez le consulter dans la rubrique **Contrats**"
    ]
  },
  facturation: {
    titre: "Gérer la facturation",
    icone: "💰",
    etapes: [
      "Allez dans **Finance** → onglet **Facturation**",
      "Cliquez sur **Générer les factures du mois** pour créer toutes les factures d'un coup",
      "Les factures apparaissent avec le statut **En attente**",
      "Quand une famille paie, cliquez sur la facture → **Marquer comme payée**",
      "Les factures en retard passent automatiquement en **rouge**",
      "Exportez un CSV pour votre comptable via l'onglet **Export**"
    ]
  },
  conges: {
    titre: "Gérer les congés",
    icone: "🏖️",
    etapes: [
      "Allez dans **Ressources Humaines** → onglet **Congés & Absences**",
      "Cliquez sur **Nouvelle demande**",
      "Sélectionnez l'employée et le type (CP, RTT, maladie...)",
      "Choisissez les dates — le nombre de jours se calcule automatiquement",
      "Validez ou refusez les demandes depuis la liste",
      "Les soldes CP/RTT se mettent à jour automatiquement"
    ]
  },
  tarifs: {
    titre: "Comprendre les tarifs",
    icone: "💡",
    etapes: [
      "Les tarifs dépendent du **nombre d'heures hebdomadaires** contractuelles",
      "Moins d'heures = tarif horaire plus élevé (et inversement)",
      "La facturation est **lissée sur 12 mois** : 47 semaines payées ÷ 12",
      "Formule : *Heures hebdo × 47 ÷ 12 × Tarif horaire = Mensualité*",
      "Les heures supplémentaires sont facturées **10€/h** le mois suivant",
      "Les 5 semaines de fermeture annuelle sont **incluses** dans le lissage"
    ]
  },
  employe: {
    titre: "Ajouter une employée",
    icone: "👥",
    etapes: [
      "Allez dans **Ressources Humaines** → onglet **Employés**",
      "Cliquez sur **Nouvelle employée**",
      "Remplissez les informations (poste, date d'embauche, type de contrat...)",
      "Saisissez les soldes initiaux de CP et RTT",
      "Sélectionnez la structure (Ptis Lu ou Choubidoux)",
      "Cliquez sur **Enregistrer**"
    ]
  },
  arrhes: {
    titre: "Gérer les arrhes",
    icone: "💳",
    etapes: [
      "Les arrhes correspondent à **1 mois de garde** selon le devis signé",
      "Elles apparaissent automatiquement à la création du devis",
      "Consultez-les dans **Finance** → onglet **Arrhes & Frais**",
      "Marquez-les comme reçues quand la famille a payé",
      "Elles s'imputent sur la première facture du contrat",
      "Les frais de dossier (70€) sont distincts des arrhes"
    ]
  }
};

export const FAQ = [
  {
    question: "comment créer un devis",
    keywords: ["devis", "créer devis", "nouveau devis", "faire devis", "tarif"],
    guide: "devis"
  },
  {
    question: "ajouter un enfant",
    keywords: ["enfant", "ajouter enfant", "nouvel enfant", "inscription", "famille", "parent"],
    guide: "enfant"
  },
  {
    question: "créer un contrat",
    keywords: ["contrat", "créer contrat", "signer", "convertir"],
    guide: "contrat"
  },
  {
    question: "facturation",
    keywords: ["facture", "facturation", "paiement", "payer", "encaisser", "finance"],
    guide: "facturation"
  },
  {
    question: "congés absences",
    keywords: ["congé", "congés", "absence", "rtt", "cp", "vacances", "arrêt maladie"],
    guide: "conges"
  },
  {
    question: "tarifs horaires",
    keywords: ["tarif", "prix", "montant", "calcul", "lissage", "mensualité", "heures"],
    guide: "tarifs"
  },
  {
    question: "ajouter employée",
    keywords: ["employée", "employé", "salarié", "personnel", "équipe", "rh"],
    guide: "employe"
  },
  {
    question: "arrhes",
    keywords: ["arrhes", "réservation", "dépôt", "frais de dossier", "acompte"],
    guide: "arrhes"
  }
];

export const SALUTATIONS = [
  "Bonjour ! Je suis **Georges**, votre majordome digital. 🤵",
  "Rebonjour ! Comment puis-je vous être utile ? 🤵",
  "À votre service ! Que puis-je faire pour vous ? 🤵"
];

export const REPONSES_INCONNUES = [
  "Je ne suis pas sûr de comprendre votre demande. Voici ce que je sais faire :",
  "Hmm, cette question me dépasse légèrement ! Voici les sujets sur lesquels je peux vous aider :",
  "Je vais transmettre ça à mes services... En attendant, voici ce dont je m'occupe :"
];

export function rechercherGuide(texte) {
  const texteLower = texte.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  for (const faq of FAQ) {
    for (const keyword of faq.keywords) {
      const kwNorm = keyword.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      if (texteLower.includes(kwNorm)) {
        return faq.guide;
      }
    }
  }
  return null;
}
